import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetLocation } from '../../../../state';
import { useGetCentersQuery } from '../../../../../../services/DimensionService/dimensionApi';

const CenterEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);
  const { data: centers = [] } = useGetCentersQuery();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetLocation({ center: event.target.value }));
  };

  return (
    <TextField
      label="Center"
      size="small"
      required
      select
      fullWidth
      value={currentAsset?.center || ''}
      onChange={handleChange}
    >
      <MenuItem value="">
        <em>Select Center</em>
      </MenuItem>
      {centers.map((c) => (
        <MenuItem key={c.value} value={c.value}>
          {c.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CenterEdit;
